import { render, staticRenderFns } from "./addOrEditNews.vue?vue&type=template&id=e728b420&scoped=true"
import script from "./addOrEditNews.vue?vue&type=script&lang=js"
export * from "./addOrEditNews.vue?vue&type=script&lang=js"
import style0 from "./addOrEditNews.vue?vue&type=style&index=0&id=e728b420&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e728b420",
  null
  
)

export default component.exports